import Select from "react-select";
import React from "react";
import {MESSAGES} from "../util/Messages";

export default class Beneficiaries extends React.Component {

  constructor(props) {
    super(props);
    this.state={
      beneficiaries:[]
    }
  }

  componentDidMount() {
    this.props.beneficiaries.forEach(beneficiary => {

      this.setState(prevState => ({
        beneficiaries: [...prevState.beneficiaries, {
          label: `${beneficiary.name} ${beneficiary.lastName} ${MESSAGES[beneficiary.status]}`,
          value: beneficiary
        }]
      }));

    })
  }

  render() {
    return (
      <div>
        <label>Selecione el beneficiario para realizar la inscripcion</label>
        <Select options={this.state.beneficiaries}
          defaultValue={this.props.beneficiary}
          value={this.props.beneficiary}
          onChange={e => this.props.handleChange(e, 'beneficiary')}
        />
      </div>

    )
  }
}
